export type IconSize = 'sm' | 'md' | 'lg'

export function fromSize(size: any) {
  switch (size) {
    case 'sm':
      return '0.9375rem'
    case 'md':
      return '1.25rem'
    case 'lg':
      return '1.5rem'
    default:
      return size
  }
}
